var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 1.28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.87891,31.92737A11.99985,11.99985,0,0,0,39.12109,48.0719L55.1604,65.715C20.67017,88.65,5.72485,121.57288,5.03418,123.12659a12.00024,12.00024,0,0,0,0,9.74707c.36426.81836,9.12793,20.25683,28.48145,39.60742C59.36621,198.32971,92.03809,211.99182,128,211.99182a131.28482,131.28482,0,0,0,51.02271-10.02832l20.09838,22.1084a11.99985,11.99985,0,0,0,17.75782-16.14453ZM128,187.99182c-29.58789,0-55.46582-10.72754-76.91406-31.88477a130.534,130.534,0,0,1-21.56543-28.0996c5.26709-9.30762,18.792-29.896,42.01684-44.27735l90.092,99.10108A109.19209,109.19209,0,0,1,128,187.99182Zm122.96582-55.11816c-.3584.80566-8.99219,19.959-28.03613,39.16211a12.0002,12.0002,0,0,1-17.041-16.90039,130.40494,130.40494,0,0,0,20.59473-27.13672,130.5251,130.5251,0,0,0-21.57031-28.11524C183.46484,78.72131,157.58789,67.99182,128,67.99182c-3.34375,0-6.69434.1416-9.959.41992a11.99961,11.99961,0,1,1-2.043-23.91211c3.94043-.33691,7.97851-.50781,12.00195-.50781,35.96191,0,68.63477,13.665,94.48535,39.51953,19.35352,19.35449,28.11719,38.79688,28.48047,39.61524A12.00024,12.00024,0,0,1,250.96582,132.87366Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hide-password-icon.ad2c76726634f528341503be88818dac.svg";
export { ForwardRef as ReactComponent };